(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-with-states"] && !Shopify.designMode) return;
  try {
    
  // populate dropdown
  var stateDropdown = document.getElementById("statedropdown");
  var dropdownlist = '';
  for (var key in stateReqData) {
    dropdownlist = dropdownlist + '<option value="'+key+'">' + stateReqData[key]['name'] + '</option>';
  }
  stateDropdown.innerHTML = stateDropdown.innerHTML + dropdownlist;

  // on dropdown change
  stateDropdown.onchange = function() {
    var statePick = stateDropdown.value;
    var stateinfodiv = document.getElementById("stateinfo");
    stateinfodiv.innerHTML = '';
    stateinfodisclaimer.innerHTML = '';
    if (statePick.length > 1) {
      var stateInfoInner = '<h2>' + stateReqData[statePick]['name'] + '</h2><ul>';
      stateInfoInner = stateInfoInner + '<li><strong>Legal for Consumer Use/Possession</strong> ';
          if (stateReqData[statePick]['values'][0]['value']) stateInfoInner = stateInfoInner + '<span>YES</span>';
          else stateInfoInner = stateInfoInner + '<span>NO</span>';
          if (stateReqData[statePick]['values'][0]['text']) stateInfoInner = stateInfoInner + ' <small>'+stateReqData[statePick]['values'][0]['text']+'</small>';
      stateInfoInner = stateInfoInner + '</li><li><strong>Other Restrictions*</strong> ';
          if (stateReqData[statePick]['values'][1]['value']) stateInfoInner = stateInfoInner + '<span>YES</span>';
          else stateInfoInner = stateInfoInner + '<span>NO</span>';
          if (stateReqData[statePick]['values'][1]['text']) stateInfoInner = stateInfoInner + ' <small>'+stateReqData[statePick]['values'][1]['text']+'</small>';
      if (stateReqData[statePick]['statelink'].length > 1) stateInfoInner = stateInfoInner + '</li><li><a href="'+stateReqData[statePick]['statelink']+'" class="button">More Info</a>';
      stateInfoInner = stateInfoInner + '</li>';
      stateInfoInner = stateInfoInner + '</ul>';
      stateinfodiv.innerHTML = stateinfodiv.innerHTML + stateInfoInner;
      stateinfodisclaimer.innerHTML = "*This information should not be construed as legal advice and is offered for information purposes only. Axon strongly recommends that you consult with the state and local laws in your state for up-to-date information regarding the legality of TASER devices in your area.";
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["state-dropdown"] && !Shopify.designMode) return;
  try {
    
  // populate dropdown
  var stateDropdown = document.getElementById("statedropdown");
  var dropdownlist = '';
  for (var key in stateReqData) {
    dropdownlist = dropdownlist + '<option value="'+key+'">' + stateReqData[key]['name'] + '</option>';
  }
  stateDropdown.innerHTML = stateDropdown.innerHTML + dropdownlist;

  // on dropdown change
  stateDropdown.onchange = function() {
    var statePick = stateDropdown.value;
    var stateinfodiv = document.getElementById("stateinfo");
    stateinfodiv.innerHTML = '';
    stateinfodisclaimer.innerHTML = '';
    if (statePick.length > 1) {
      var stateInfoInner = '<h2>' + stateReqData[statePick]['name'] + '</h2><ul>';
      stateInfoInner = stateInfoInner + '<li><strong>Legal for Consumer Use/Possession</strong> ';
          if (stateReqData[statePick]['values'][0]['value']) stateInfoInner = stateInfoInner + '<span>YES</span>';
          else stateInfoInner = stateInfoInner + '<span>NO</span>';
          if (stateReqData[statePick]['values'][0]['text']) stateInfoInner = stateInfoInner + ' <small>'+stateReqData[statePick]['values'][0]['text']+'</small>';
      stateInfoInner = stateInfoInner + '</li><li><strong>Other Restrictions*</strong> ';
          if (stateReqData[statePick]['values'][1]['value']) stateInfoInner = stateInfoInner + '<span>YES</span>';
          else stateInfoInner = stateInfoInner + '<span>NO</span>';
          if (stateReqData[statePick]['values'][1]['text']) stateInfoInner = stateInfoInner + ' <small>'+stateReqData[statePick]['values'][1]['text']+'</small>';
      if (stateReqData[statePick]['statelink'].length > 1) stateInfoInner = stateInfoInner + '</li><li><a href="'+stateReqData[statePick]['statelink']+'" class="button">More Info</a>';
      stateInfoInner = stateInfoInner + '</li>';
      stateInfoInner = stateInfoInner + '</ul>';
      stateinfodiv.innerHTML = stateinfodiv.innerHTML + stateInfoInner;
      stateinfodisclaimer.innerHTML = "*This information should not be construed as legal advice and is offered for information purposes only. Axon strongly recommends that you consult with the state and local laws in your state for up-to-date information regarding the legality of TASER devices in your area.";
    }
  }

  } catch(e) { console.error(e); }
})();
})();
